import { createSlice } from "@reduxjs/toolkit";
import {
  getCoursesInfoReport,
  getCoursesAgesInfoReport,
  getCoursesInfoBySpecReport,
  getCoursesInfoByRegionReport,
  getCollegeGraduatesReport,
  getCollegeDirectorsInfoReport,
  getCollegeCafedrasInfoReport,
  getAttendanceInSemester,
  getCoursesByLanguage,
  getGraduateCoursesInfoByLanguage,
  getEducationQualityInSemesters,
  getCoursesAttendenceInSemesters,
  getGraduateCoursesBySpecReport,
  getStudentTypeList,
} from "./api";
import { getSemester } from "pages/admin/api";

const initialState = {
  coursesInfoReport: null,
  coursesInfoReportLoading: false,
  coursesAgesInfoReport: null,
  coursesAgesInfoReportLoading: false,
  coursesInfoBySpecReport: null,
  coursesInfoBySpecReportLoading: false,

  coursesInfoByRegionReport: null,
  coursesInfoByRegionReportLoading: false,
  collegeGraduatesReport: null,
  collegeGraduatesReportLoading: false,

  collegeDirectorsInfoReport: null,
  collegeDirectorsInfoReportLoading: false,
  collegeCafedrasInfoReport: null,
  collegeCafedrasInfoReportLoading: false,
  attendanceInsemester: null,
  attendanceInSemesterLoading: false,
  coursesBylanguage: null,
  coursesBylanguageLoading: false,

  // state for report 10, 11, 12, 13
  graduateCoursesInfoByLanguage: null,
  graduateCoursesInfoByLanguageLoading: false,
  educationQualityInSemesters: null,
  educationQualityInSemestersLoading: false,
  coursesAttendenceInSemesters: null,
  coursesAttendenceInSemestersLoading: false,
  graduateCoursesBySpecReport: null,
  graduateCoursesBySpecReportLoading: false,
  semester: null,
  semesterLoading: false,
};

const reportSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCoursesInfoReport.pending, (state, action) => {
      state.coursesInfoReportLoading = true;
    });
    builder.addCase(getCoursesInfoReport.fulfilled, (state, action) => {
      state.coursesInfoReport = action.payload;
      state.coursesInfoReportLoading = false;
    });
    builder.addCase(getCoursesInfoReport.rejected, (state, action) => {
      state.coursesInfoReportLoading = false;
    });

    builder.addCase(getCoursesAgesInfoReport.pending, (state, action) => {
      state.coursesAgesInfoReportLoading = true;
    });
    builder.addCase(getCoursesAgesInfoReport.fulfilled, (state, action) => {
      state.coursesAgesInfoReport = action.payload;
      state.coursesAgesInfoReportLoading = false;
    });
    builder.addCase(getCoursesAgesInfoReport.rejected, (state, action) => {
      state.coursesAgesInfoReportLoading = false;
    });

    builder.addCase(getCoursesInfoBySpecReport.pending, (state, action) => {
      state.coursesInfoBySpecReportLoading = true;
    });
    builder.addCase(getCoursesInfoBySpecReport.fulfilled, (state, action) => {
      state.coursesInfoBySpecReport = action.payload;
      state.coursesInfoBySpecReportLoading = false;
    });
    builder.addCase(getCoursesInfoBySpecReport.rejected, (state, action) => {
      state.coursesInfoBySpecReportLoading = false;
    });

    builder.addCase(getCoursesInfoByRegionReport.pending, (state, action) => {
      state.coursesInfoByRegionReportLoading = true;
    });
    builder.addCase(getCoursesInfoByRegionReport.fulfilled, (state, action) => {
      state.coursesInfoByRegionReport = action.payload;
      state.coursesInfoByRegionReportLoading = false;
    });
    builder.addCase(getCoursesInfoByRegionReport.rejected, (state, action) => {
      state.coursesInfoByRegionReportLoading = false;
    });

    builder.addCase(getCollegeGraduatesReport.pending, (state, action) => {
      state.collegeGraduatesReportLoading = true;
    });
    builder.addCase(getCollegeGraduatesReport.fulfilled, (state, action) => {
      state.collegeGraduatesReport = action.payload;
      state.collegeGraduatesReportLoading = false;
    });
    builder.addCase(getCollegeGraduatesReport.rejected, (state, action) => {
      state.collegeGraduatesReportLoading = false;
    });

    builder.addCase(getCollegeDirectorsInfoReport.pending, (state, action) => {
      state.collegeDirectorsInfoReportLoading = true;
    });
    builder.addCase(
      getCollegeDirectorsInfoReport.fulfilled,
      (state, action) => {
        state.collegeDirectorsInfoReport = action.payload;
        state.collegeDirectorsInfoReportLoading = false;
      }
    );
    builder.addCase(getCollegeDirectorsInfoReport.rejected, (state, action) => {
      state.collegeDirectorsInfoReportLoading = false;
    });

    builder.addCase(getCollegeCafedrasInfoReport.pending, (state, action) => {
      state.collegeCafedrasInfoReportLoading = true;
    });
    builder.addCase(getCollegeCafedrasInfoReport.fulfilled, (state, action) => {
      state.collegeCafedrasInfoReport = action.payload;
      state.collegeCafedrasInfoReportLoading = false;
    });
    builder.addCase(getCollegeCafedrasInfoReport.rejected, (state, action) => {
      state.collegeCafedrasInfoReportLoading = false;
    });

    builder.addCase(getAttendanceInSemester.pending, (state, action) => {
      state.attendanceInSemesterLoading = true;
    });
    builder.addCase(getAttendanceInSemester.fulfilled, (state, action) => {
      state.attendanceInsemester = action.payload;
      state.attendanceInSemesterLoading = false;
    });
    builder.addCase(getAttendanceInSemester.rejected, (state, action) => {
      state.attendanceInSemesterLoading = false;
    });

    builder.addCase(getCoursesByLanguage.pending, (state, action) => {
      state.coursesBylanguageLoading = true;
    });
    builder.addCase(getCoursesByLanguage.fulfilled, (state, action) => {
      state.coursesBylanguage = action.payload;
      state.coursesBylanguageLoading = false;
    });
    builder.addCase(getCoursesByLanguage.rejected, (state, action) => {
      state.coursesBylanguageLoading = false;
    });

    builder.addCase(getGraduateCoursesBySpecReport.pending, (state, action) => {
      state.graduateCoursesBySpecReportLoading = true;
    });
    builder.addCase(
      getGraduateCoursesBySpecReport.fulfilled,
      (state, action) => {
        state.graduateCoursesBySpecReport = action.payload;
        state.graduateCoursesBySpecReportLoading = false;
      }
    );
    builder.addCase(
      getGraduateCoursesBySpecReport.rejected,
      (state, action) => {
        state.graduateCoursesBySpecReportLoading = false;
      }
    );

    builder.addCase(getEducationQualityInSemesters.pending, (state, action) => {
      state.educationQualityInSemestersLoading = true;
    });
    builder.addCase(
      getEducationQualityInSemesters.fulfilled,
      (state, action) => {
        state.educationQualityInSemesters = action.payload;
        state.educationQualityInSemestersLoading = false;
      }
    );
    builder.addCase(
      getEducationQualityInSemesters.rejected,
      (state, action) => {
        state.educationQualityInSemestersLoading = false;
      }
    );

    builder.addCase(
      getCoursesAttendenceInSemesters.pending,
      (state, action) => {
        state.coursesAttendenceInSemestersLoading = true;
      }
    );
    builder.addCase(
      getCoursesAttendenceInSemesters.fulfilled,
      (state, action) => {
        state.coursesAttendenceInSemesters = action.payload;
        state.coursesAttendenceInSemestersLoading = false;
      }
    );
    builder.addCase(
      getCoursesAttendenceInSemesters.rejected,
      (state, action) => {
        state.coursesAttendenceInSemestersLoading = false;
      }
    );

    builder.addCase(getSemester.pending, (state, action) => {
      state.semesterLoading = true;
    });
    builder.addCase(getSemester.fulfilled, (state, action) => {
      state.semester = action.payload;
      state.semesterLoading = false;
    });
    builder.addCase(getSemester.rejected, (state, action) => {
      state.semesterLoading = false;
    });

    builder.addCase(
      getGraduateCoursesInfoByLanguage.pending,
      (state, action) => {
        state.graduateCoursesInfoByLanguageLoading = true;
      }
    );
    builder.addCase(
      getGraduateCoursesInfoByLanguage.fulfilled,
      (state, action) => {
        state.graduateCoursesInfoByLanguage = action.payload;
        state.graduateCoursesInfoByLanguageLoading = false;
      }
    );
    builder.addCase(
      getGraduateCoursesInfoByLanguage.rejected,
      (state, action) => {
        state.graduateCoursesInfoByLanguageLoading = false;
      }
    );
  },
});

export default reportSlice.reducer;
